export default "__VITE_PUBLIC_ASSET__724ff198__"